import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './NewsMedia.css';

const articles = [
  {
    slug: 'adaptive-fashion-2022',
    title: 'Adaptive Fashion 2022: The Shapes United',
    date: 'September 2022',
    summary:
      'How The Shapes United is changing adaptive fashion with magnetic fastenings, sensory-friendly fabrics, and inclusive design.',
    image: '/assets/products/01-tsu-side-opening-pants.jpg',
    content: [
      'Our Adaptive Fashion 2022 feature highlights how magnetic and Velcro fastenings, flat seams, and tag-free designs make dressing easier for everyone.',
      'We design alongside occupational therapists, carers, and the community to solve real-world dressing challenges without sacrificing style.',
      'From side-opening pants to wrap boxers and sensory tees, every piece is built for confidence, independence, and comfort.',
    ],
  },
  {
    slug: 'news-and-media-hub',
    title: 'News & Media Hub',
    date: 'Ongoing',
    summary:
      'Company updates, product stories, and accessibility insights direct from The Shapes United team and community.',
    image: '/assets/products/01-tsu-comfy-tshirt_595b0f46-57f4-40b0-b7f6-205c3c6e10bf.jpg',
    content: [
      'Stay up to date with new drops, restocks, and collaborations across adaptive, sensory, and custom solutions.',
      'We share behind-the-scenes design notes, community spotlights, and tips for dressing with comfort and independence.',
      'Watch this space as we continue to expand our range and share more stories from The Shapes United community.',
    ],
  },
  {
    slug: 'inclusive-design-spotlight',
    title: 'Inclusive Design Spotlight',
    date: 'Feature',
    summary:
      'Sensory-friendly tops, adaptive bottoms, and custom-made solutions crafted with a focus on accessibility.',
    image: '/assets/products/01-tsu-boat-neck-short-sleeve-top_0f018091-75bc-4b87-a896-f9f2a5ddfeca.jpg',
    content: [
      'Our inclusive design approach prioritizes soft-touch fabrics, seamless finishes, and easy closures for everyday ease.',
      'Each garment is iterated with feedback from users, therapists, and carers to make sure it works in real life.',
      'Inclusive design isn’t a trend—it’s our standard for every collection we release.',
    ],
  },
];

function NewsMedia() {
  const { slug } = useParams();
  const article = slug ? articles.find((a) => a.slug === slug) : null;

  if (article) {
    return (
      <div className="news-page">
        <header className="news-hero">
          <p className="eyebrow">News &amp; Media</p>
          <h1>{article.title}</h1>
          <p>{article.summary}</p>
          <Link className="back-link" to="/news">
            ← Back to News &amp; Media
          </Link>
        </header>

        <article className="news-article">
          <div className="news-article-image">
            <img src={article.image} alt={article.title} />
          </div>
          <div className="news-article-body">
            <p className="news-date">{article.date}</p>
            {article.content.map((para, idx) => (
              <p key={idx} className="news-paragraph">
                {para}
              </p>
            ))}
          </div>
        </article>
      </div>
    );
  }

  return (
    <div className="news-page">
      <header className="news-hero">
        <p className="eyebrow">News &amp; Media</p>
        <h1>The Shapes United</h1>
        <p>
          Press highlights, blog updates, and featured stories about inclusive,
          adaptive, and sensory-friendly design—all available right here.
        </p>
      </header>

      <section className="news-grid">
        {articles.map((item) => (
          <Link key={item.slug} to={`/news/${item.slug}`} className="news-card">
            <div className="news-image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="news-body">
              <p className="news-date">{item.date}</p>
              <h3>{item.title}</h3>
              <p className="news-summary">{item.summary}</p>
              <span className="news-link">Read more →</span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}

export default NewsMedia;
